import { render, staticRenderFns } from "./CompareList.vue?vue&type=template&id=5ee845e0&scoped=true&"
import script from "./CompareList.vue?vue&type=script&lang=js&"
export * from "./CompareList.vue?vue&type=script&lang=js&"
import style0 from "./CompareList.vue?vue&type=style&index=0&id=5ee845e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee845e0",
  null
  
)

export default component.exports